import { getData, putDataWithoutAuth } from "./APIServiceInterface";
import axios from "axios";

const token = localStorage.getItem("msal.idtoken");

export const getPreSignedUrl = (modelId, file) => {
  return getData(
    `maintenance/preSignedUrl/get?filename=${file}&modelId=${modelId}&httpVerb=2&isMapping=true`
  );
};

export const getPreSignedUrlToDownload = (modelId, file) => {
  return getData(
    `maintenance/preSignedUrl/get?filename=${file}&modelId=${modelId}&httpVerb=0&isMapping=true`
  );
};

export const uploadNewJSONToS3 = async (preSignedUrl, payload) => {
  return putDataWithoutAuth(preSignedUrl, payload);
};

export const getJsonFilesForModels = (modelId) =>{
  return getData(`maintenance/GetS3filesInfo?modelId=${modelId}&isMapping=true`)
}

export const clearCacheAfterFileUpload = async () => {
  return getData(`/maintenance/ClearCache/get`);
}

export const sampleJsonPreSignedUrlToDownload = (file, type) => {
  return getData(
    `maintenance/GetSampleSignedURL?fileName=${file}&regionName=na&httpVerb=0&sourceType=${type}`
  );
};